export const agenda = {
  agendaDuration: 'продолжительность',
  agendaCurtainCopy: 'Скопировать ссылку',
  agendaCurtainFlag: 'Пожаловаться',
  agendaCurtainFlagSent: 'Жалоба отправлена',
  agendaLinkCopied: 'Ссылка скопирована!',
  agendaStartsAt: 'Начинается в ',
  agendaEndsAt: 'Заканчивается в ',
  agendaSpeakers: 'Спикеры',
  agendaSeeAllSpeakers: 'Все',
  agendaAddToSchedule: 'Добавить в мое расписание',
  agendaRemoveFromSchedule: 'Убрать из моего расписания',
  agendaAddedToSchedule: 'Добавлено в мое расписание!',
  agendaRemovedFromSchedule: 'Убрано из моего расписания!',
  agendaCalendar: 'Календарь',
  agendaAddToCalendar: 'Добавить в системный календарь?',
  agendaCalendarSkip: 'Пропустить',
  agendaCalendarAdd: 'Добавить',
  agendaNow: 'СЕЙЧАС',
  agendaModerators: 'Модераторы'
}
